import React from 'react'
import { Tooltip } from '@mui/material'
import * as jdenticon from 'jdenticon'

interface UserIconProps {
  userId: number;
  userName: string;
  size?: number;
}

const UserIcon: React.FC<UserIconProps> = ({ userId, userName, size = 24 }) => {
  // Generate a unique SVG based on the userId
  const svgString = jdenticon.toSvg(userId.toString(), size)

  // Convert the SVG string to a data URL
  const dataUrl = `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`

  return (
    <Tooltip title={userName} arrow placement="top">
      <img
        src={dataUrl}
        alt={userName}
        className="user-icon"
        width={size}
        height={size}
        style={{ borderRadius: '50%', marginRight: '4px', verticalAlign: 'middle' }}
      />
    </Tooltip>
  )
}

export default UserIcon